import i18next from 'i18next';
import { toast } from 'sonner';
import {
    isProgrammaticReportFailure,
    normalizeProgrammaticReportFailure,
    programmaticReportFailureDefaultMessage,
    programmaticReportFailureMessageKey,
} from '../programmatic-report-failure.js';

const DEFAULT_REPORT_RUN_MESSAGES = Object.freeze({
    noRecords: 'No records match the selected criteria.',
    accessDenied: 'You do not have permission for this report.',
    requestFailed: 'Report could not be generated.',
});

export class ReportRunsIntegration {
    constructor(service) { this.service = service; }

    async count(input) {
        try {
            const response = await this.service.count(input);
            const count = Number(response.data?.matchedCount);
            return Number.isInteger(count) && count >= 0 ? count : null;
        } catch {
            return null;
        }
    }

    async run(input) {
        try {
            const response = await this.service.run(input);
            return { success: true, data: response.data };
        } catch (error) {
            const status = Number(error?.statusCode ?? error?.status);
            const failure = normalizeProgrammaticReportFailure(error);
            const programmatic = isProgrammaticReportFailure(failure);
            let messageKey = 'requestFailed';
            let defaultValue = DEFAULT_REPORT_RUN_MESSAGES.requestFailed;
            if (error?.code === 'REPORT_NO_RECORDS') {
                messageKey = 'noRecords';
                defaultValue = DEFAULT_REPORT_RUN_MESSAGES.noRecords;
            } else if (status === 401 || status === 403) {
                messageKey = 'accessDenied';
                defaultValue = DEFAULT_REPORT_RUN_MESSAGES.accessDenied;
            } else if (programmatic) {
                const failureMessageKey = programmaticReportFailureMessageKey(failure);
                messageKey = `programmaticError.${failureMessageKey}`;
                defaultValue = programmaticReportFailureDefaultMessage(failureMessageKey);
            }
            const message = i18next.t(`reportSurface:detailedReporting.${messageKey}`, {
                defaultValue,
            });
            toast.error(message);
            return {
                success: false,
                error: message,
                ...(programmatic ? { failure } : {}),
            };
        }
    }
}
